export default __webpack_public_path__ + "static/media/manage_patients_selected.902e5b87.svg";